import { labelService } from '@/utils/labels';
import { mergeTenantSettings } from '@/utils/util';

export class Tenant {
	constructor({ tenantId, name, shortCode, settings } = {}) {
		this.tenantId = tenantId;
		this.name = name;
		this.shortCode = shortCode;
		const mergedSettings = mergeTenantSettings(tenantId, settings);
		this.settings = new TenantSettings(mergedSettings);
	}

	getLabel(labelKey, defaultValue = '') {
		console.log(labelKey, defaultValue);
		console.log(this.tenantId);
		const tenantId = this.tenantId;
		return labelService.getLabel(tenantId, labelKey, defaultValue);
	}

	getLabels() {
		const tenantId = this.tenantId;
		return labelService.getLabels(tenantId);
	}

	hasLabels() {
		const tenantId = this.tenantId;
		return labelService.hasLabels(tenantId);
	}
}

export class TenantSettings {
	constructor({
		brandImages = new TenantBrandImages(),
		brandName = 'Locumbase',
		brandUrl = 'https://www.locumbase.com',
		brandYoutubeUrl = '',
		brandAdvertImageLeft = '',
		brandAdvertImageRight = '',
		theme = new TenantTheme(),
		wallet = new Wallet(),
		pricing = new Pricing(),
		links = new TenantLinks(),
		workflow = new TenantWorkflow(),
		navigation = new TenantNavigation(),
	} = {}) {
		this.brandImages = new TenantBrandImages(brandImages);
		this.brandName = brandName;
		this.brandUrl = brandUrl;
		this.brandYoutubeUrl = brandYoutubeUrl;
		this.brandAdvertImageLeft = brandAdvertImageLeft;
		this.brandAdvertImageRight = brandAdvertImageRight;
		this.links = new TenantLinks(links);
		this.theme = new TenantTheme(theme);
		this.wallet = new Wallet(wallet);
		this.pricing = new Pricing(pricing);
		this.workflow = new TenantWorkflow(workflow);
		this.navigation = new TenantNavigation(navigation);
	}

	set(vuetify) {
		document.title = this.brandName;
		this.theme.set(vuetify);
		this.setFavicon();
		this.loadGTMTag();
		this.loadChat();
	}

	setFavicon() {
		if (!this.brandImages.favicon || !this.brandImages.favicon.auth) return;
		var link = document.querySelector("link[rel~='icon']");
		if (!link) {
			link = document.createElement('link');
			link.rel = 'icon';
			document.head.appendChild(link);
		}
		link.href = this.brandImages.favicon.auth;
	}

	loadChat() {
		if (this.workflow.support.brevo.active) {
			const key = process.env.VUE_APP_BREVO_CONVERSATIONS_CLIENT_KEY;
			this._createBrevoScript(key);
		} else if (this.workflow.support.tawk.active) {
			this._setChatScript('tawk-chat');
		}
	}

	loadGTMTag() {
		const gtmKey = process.env.VUE_APP_GTM_KEY;
		if (gtmKey) {
			this._createGTMScripts(gtmKey);
		}
	}

	_setChatScript(chatFileName) {
		const script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = `js/${chatFileName}.js`;
		document.head.appendChild(script);
	}

	_createBrevoScript(clientKey) {
		window.BrevoConversationsID = clientKey;
		window.BrevoConversations =
			window.BrevoConversations ||
			function () {
				(window.BrevoConversations.q = window.BrevoConversations.q || []).push(arguments);
			};

		const script = document.createElement('script');
		script.async = true;
		script.src = `https://conversations-widget.brevo.com/brevo-conversations.js`;
		document.head.appendChild(script);
	}

	_createGTMScripts(gtmKey) {
		this._createGTMHeadScript(gtmKey);
		this._createGTMBodyScript(gtmKey);
	}

	_createGTMHeadScript(gtmKey) {
		const script = document.createElement('script');
		script.textContent = `
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
			(function(w,d,s,l,i){
				w[l]=w[l]||[];w[l].push({'gtm.start':
				new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
				j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
				'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
			})(window,document,'script','dataLayer','${gtmKey}');
		`;
		document.head.appendChild(script);
	}

	_createGTMBodyScript(gtmKey) {
		const noscript = document.createElement('noscript');
		const iframe = document.createElement('iframe');
		iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmKey}`;
		iframe.height = '0';
		iframe.width = '0';
		iframe.style.display = 'none';
		iframe.style.visibility = 'hidden';
		noscript.appendChild(iframe);
		document.body.insertBefore(noscript, document.body.firstChild);
	}
}

export class TenantTheme {
	constructor({
		primary = '#FF5F05', //Orange
		secondary = '#4D88A1', //Cyan
		accent = '#009CEF', // Blue
		error = '#F44336', //Red
		anchor = '#FF5F05',
		background = '#FFFFFF',
	} = {}) {
		this.primary = primary;
		this.secondary = secondary;
		this.accent = accent;
		this.error = error;
		this.anchor = anchor;
		this.background = background;
	}

	set(vuetify) {
		vuetify.framework.theme.themes.light.primary = this.primary;
		vuetify.framework.theme.themes.light.secondary = this.secondary;
		vuetify.framework.theme.themes.light.accent = this.accent;
		vuetify.framework.theme.themes.light.error = this.error;
		vuetify.framework.theme.themes.light.anchor = this.anchor;
		vuetify.framework.theme.themes.light.background = this.background;
	}
}

const iHeaderLogos = {
	app: {
		light: '',
		dark: '',
	},
	auth: {
		light: '',
		dark: '',
	},
};

const iDashboardImage = {
	company: '',
	professional: '',
};

const iFavicon = {
	app: '',
	auth: '',
};

const iRates = {
	publicHolidays: 0,
	saturday: 0,
	sundays: 0,
	weekdays: 0,
};

const iTawk = {
	active: true,
};

const iBrevo = {
	active: false,
};

const iPlaceholders = {
	professional: '',
	company: '',
};

export class TenantBrandImages {
	constructor({ headerLogos = iHeaderLogos, dashboardImage = iDashboardImage, favicon = iFavicon, placeholders = iPlaceholders } = {}) {
		this.headerLogos = headerLogos;
		this.dashboardImage = dashboardImage;
		this.favicon = favicon;
		this.placeholders = {
			professional: placeholders?.professional || '',
			company: placeholders?.company || '',
		};
	}
}

export class Wallet {
	constructor({ show = false } = {}) {
		this.show = show;
	}
}

export class Pricing {
	constructor({ show = false } = {}) {
		this.show = show;
	}
}

export class TenantWorkflow {
	constructor({ professionalProfile = new TenantWorkflowProfessionalProfile(), companyProfile = new TenantWorkflowCompanyProfile(), support = new TenantSupport() } = {}) {
		this.professionalProfile = new TenantWorkflowProfessionalProfile(professionalProfile);
		this.companyProfile = new TenantWorkflowCompanyProfile(companyProfile);
		this.support = new TenantSupport(support);
	}
}

export class TenantWorkflowCompanyProfile {
	constructor({
		seeAllProfessionCategories = false,
		hideIndustryPicker = false,
		defaultIndustry = '',
		showEstablishmentType = false,
		establishmentTypeRequired = false,
		showAdditionalSkillsFilter = false,
		matchProfessionOrSkills = false,
		filterByEstablishmentType = false,
	} = {}) {
		this.seeAllProfessionCategories = seeAllProfessionCategories;
		this.hideIndustryPicker = hideIndustryPicker;
		this.defaultIndustry = defaultIndustry;
		this.showEstablishmentType = showEstablishmentType;
		this.establishmentTypeRequired = establishmentTypeRequired;
		this.showAdditionalSkillsFilter = showAdditionalSkillsFilter;
		this.matchProfessionOrSkills = matchProfessionOrSkills;
		this.filterByEstablishmentType = filterByEstablishmentType;
	}
}

export class TenantWorkflowProfessionalProfile {
	constructor({
		autoApprove = false,
		hasFixedRates = false,
		rates = iRates,
		invitesActive = true,
		hideRegistrationBodyField = false,
		hideRegistrationNumberField = false,
		professionalCalendar = new TenantWorkflowProfessionalCalendarSettings(),
		minimumHourlyRate = null,
		defaultShiftStartTime = '09:00',
		defaultShiftEndTime = '17:00',
		defaultCompanyLanguages = [],
		workExperienceIcon = 'mdi-medical-bag',
		showExpandedShiftSummary = false,
		allowOptionalFormalTraining = false,
	} = {}) {
		this.autoApprove = autoApprove;
		this.hasFixedRates = hasFixedRates;
		this.rates = rates;
		this.invitesActive = invitesActive;
		this.hideRegistrationBodyField = hideRegistrationBodyField;
		this.hideRegistrationNumberField = hideRegistrationNumberField;
		this.professionalCalendar = new TenantWorkflowProfessionalCalendarSettings(professionalCalendar);
		this.minimumHourlyRate = minimumHourlyRate;
		this.defaultShiftStartTime = defaultShiftStartTime;
		this.defaultShiftEndTime = defaultShiftEndTime;
		this.defaultCompanyLanguages = defaultCompanyLanguages;
		this.workExperienceIcon = workExperienceIcon;
		this.showExpandedShiftSummary = showExpandedShiftSummary;
		this.allowOptionalFormalTraining = allowOptionalFormalTraining;
	}
}

export class TenantSupport {
	constructor({ tawk = iTawk, brevo = iBrevo } = {}) {
		this.tawk = tawk;
		this.brevo = brevo;
	}
}

export class TenantLinks {
	constructor({ faq = '', terms = '', blog = '', contact = '', downloads = '', tutorials = '', whatsappNumber = '', whatsappDefaultMessage = '' } = {}) {
		this.faq = faq;
		this.terms = terms;
		this.blog = blog;
		this.contact = contact;
		this.downloads = downloads;
		this.tutorials = tutorials;
		this.whatsappNumber = whatsappNumber;
		this.whatsappDefaultMessage = whatsappDefaultMessage;
	}
}

export class TenantNavigation {
	constructor({ hideTutorials = false } = {}) {
		this.hideTutorials = hideTutorials;
	}
}

export class TenantWorkflowProfessionalCalendarSettings {
	constructor({ eventColors = {} } = {}) {
		this.eventColors = {
			...TenantWorkflowProfessionalCalendarEventColors,
			...(eventColors || {}),
		};
	}
}

export const TenantWorkflowProfessionalCalendarEventColors = {
	applicationSent: 'light-blue darken-1',
};

export default Tenant;
